"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepsList = void 0;
const react_1 = __importDefault(require("react"));
const active_step_context_1 = require("./active-step-context");
const stepper_styles_1 = require("./stepper.styles");
require("./stepper.types");
const StepsList = ({ children, value, onChange }) => {
    return (react_1.default.createElement(active_step_context_1.ActiveStepContext.Provider, { value: { activeStep: value, setActiveStep: onChange } },
        react_1.default.createElement(stepper_styles_1.StepperNavigation, null, children)));
};
exports.StepsList = StepsList;
